import { styled } from "@mui/material";

import svg from "./correlated-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const CorrelatedIcon = makeSvgIcon(svg);

export default CorrelatedIcon;

export const CorrelatedOutputIcon = styled(CorrelatedIcon)(({ theme }) => ({
  backgroundColor: theme.palette.candidate.main,
  borderRadius: "50%",
  color: theme.palette.common.white,
}));
